import React, { memo, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
export default memo(({ data, isConnectable }) => {
  const [notes, setNotes] = useState(data.notes ? data.notes : "");
  function updateNotes(value) {
    console.log(value.target.value);
    setNotes(value.target.value);
    data.notes = encodeURIComponent((value.target.value));
    //data.actionExecutor({ action: 1, notes: value.target.value });
  }
  function onDelete(id) {
    data.onDelete(id);
  }

  const safeDecode = (text) => {
    try {
      return decodeURIComponent(text);
    } catch (error) {
      return text; // Return as-is if decoding fails
    }
  };
  return (
    <>
      <div className="notesHeader icon_dark">
        Notes
        <MDBIcon
          fas
          icon="times"
          className="cursor-pointer"
          color="light"
          onClick={() => onDelete(data.id)}
        />
      </div>
      <div id="board">
        <div className="nodeBody notesreactflowtextarea">
          <div className="text">
            <textarea
              defaultValue={safeDecode(notes)}
              rows={8}
              className="cnt"
              placeholder="Enter note description here"
              onChange={(value) => updateNotes(value)}
            />
          </div>
        </div>
      </div>
    </>
  );
});
